import { render, staticRenderFns } from "./SalesRoot.vue?vue&type=template&id=143e455f&lang=pug&"
import script from "./SalesRoot.vue?vue&type=script&lang=js&"
export * from "./SalesRoot.vue?vue&type=script&lang=js&"
import style0 from "./SalesRoot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports